<h1 mat-dialog-title>Consumo Detallado</h1>
<div mat-dialog-content class="dialog-content">
  <div class="logo-container" *ngIf="consumos && consumos.consumos.length > 0">
    <div class="logo" *ngFor="let consumo of consumos.consumos">
      <img [src]="consumo.ulrImg" [alt]="consumo.type" class="logo-img">
      <div class="value">{{consumo.consume}} litro/s</div>
    </div>
  </div>
</div>
<div *ngIf="!consumos || consumos.consumos.length === 0" class="no-data">
  <label>SIN DATOS</label>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cerrar</button>
</div>
